

var Urank = require('./src/')

module.exports = Urank;

// module.exports = require('./src/js/controller/urank');


//////////////////
// WEBPACK FOOTER
// ../index.js
// module id = 147
// module chunks = 0